/**
 * Schema.org structured data implementation for Florida's Scenic Byways
 * This helps search engines better understand the content and purpose of the site
 */

document.addEventListener('DOMContentLoaded', function () {
	// Create the TouristAttraction Schema for each byway
	function createBywaySchema(bywayCode, bywayName, description, county) {
		return {
			"@context": "https://schema.org",
			"@type": "TouristAttraction",
			"name": bywayName,
			"description": description,
			"address": {
				"@type": "PostalAddress",
				"addressRegion": "FL",
				"addressCountry": "US",
				"addressLocality": county ? `${county} County` : "Florida"
			},
			"touristType": ["Scenic Drive", "Road Trip"]
		};
	}

	// Add byway schemas when they are displayed
	if (window.addEventListener) {
		window.addEventListener('bywayDetailsDisplayed', function (event) {
			if (event.detail && event.detail.byway) {
				const { code, name, description, county } = event.detail.byway;
				const bywaySchema = createBywaySchema(code, name, description, county);
				appendSchemaToHead(bywaySchema, `byway-schema-${code}`);
			}
		});
	}

	// Helper function to append schema to head
	function appendSchemaToHead(schema, id = 'website-schema') {
		// Remove existing schema with same ID if it exists
		const existingSchema = document.getElementById(id);
		if (existingSchema) {
			existingSchema.remove();
		}

		// Create and append new schema
		const script = document.createElement('script');
		script.type = 'application/ld+json';
		script.id = id;
		script.textContent = JSON.stringify(schema);
		document.head.appendChild(script);
	}
});
